
import { TranslationKey } from '../types';
import { navigation } from './categories/es/navigation';
import { uiActions } from './categories/ui-actions';
import { embedding } from './categories/embedding';
import { dialog } from './categories/dialog';
import { playback } from './categories/playback';
import { tracking } from './categories/tracking';
import { speedTesting } from './categories/speed-testing';
import { featureManagement } from './categories/feature-management';
import { autoplayOverlay } from './categories/autoplay-overlay';
import { videoContent } from './categories/video-content';
import { userAccount } from './categories/user-account';
import { userProfile } from './categories/user-profile';
import { VisualElements } from './categories/visual-elements';
import { pagesEs } from './categories/pages-es';

export const es = {
  ...navigation,
  ...uiActions,
  ...embedding,
  ...dialog,
  ...playback,
  ...tracking,
  ...speedTesting,
  ...featureManagement,
  ...autoplayOverlay,
  ...videoContent,
  ...userAccount,
  ...userProfile,
  ...VisualElements,
  // Spanish-specific translations for personal profile
  personal: 'Personal',
  language: 'Idioma',
  firstName: 'Nombre',
  lastName: 'Apellido',
  email: 'Correo electrónico',
  company: 'Empresa',
  currentPassword: 'Contraseña actual',
  newPassword: 'Nueva contraseña',
  confirmNewPassword: 'Confirmar nueva contraseña',
  passwordRequirements: 'Requisitos de contraseña',
  passwordRequirement1: 'Mínimo 8 caracteres',
  passwordRequirement2: 'Al menos un número',
  passwordRequirement3: 'Al menos una mayúscula',
  security: 'Seguridad',
  ...pagesEs,
} as Record<TranslationKey, string>;
